import { HeaderContainer } from "./Header.styles";


export default function Header(){
  return(
    <HeaderContainer><span>Product List</span></HeaderContainer>
  )
}